export default {
    
    en: {
        title: 'Risk Management',
        bankCardCheck: 'Bank card verification',
        mobile: 'Mobile',
        bankAccountNo: 'BankAccount NO',
        ifscCode: 'IFSC CODE',
    },
}
